import { FormikProps } from "formik";
import { OpretFirmaStep1Formik } from "../../opretFirmaInterface";
import { TextInputFormik } from "../../../../formcontrols/InputItem";
import AddressFormControl from "../../../../formcontrols/AddressFormControl";
import { SelectFormik } from "../../../../formcontrols/Select";
import { AddressGenericFormSet } from "../../../../formcontrols/sets/AddressGenericFormSet";
import { useKodeListe } from "../../../../../hooks/useQueries";

export function NoCVRFormDKGL({
  formik,
}: {
  formik: FormikProps<OpretFirmaStep1Formik>;
}) {
  const { values } = formik;
  const { getKodelisteError, getKodelisteIsLoading, kodeliste } = useKodeListe(
    "VirksomhedsformKode",
  );

  if (getKodelisteError) return <div>Fejl</div>;
  if (getKodelisteIsLoading) return <div>Henter koder ...</div>;
  if (!kodeliste) return null;

  const labelData: LabelValueType[] = (kodeliste as KodeListeEnumType[]).map(
    (virksomhedsform) => {
      return {
        label: virksomhedsform.navn,
        value: virksomhedsform.id,
      };
    },
  );
  return (
    <>
      <div className="w-100 position-relative">
        <TextInputFormik
          formik={formik}
          config={{
            component: "textinput",
            id: "navn",
            label: "Firmanavn",
            isRequired: true,
            initialValue: "",
            placeholder: "Indtast firmanavn",
          }}
        />
      </div>
      <div className="w-100 position-relative">
        <SelectFormik
          config={{
            component: "select",
            id: "virksomhedsform",
            label: "Virksomhedsform",
            isRequired: true,
            placeholder: "Vælg ...",
          }}
          formik={formik}
          data={labelData}
        />
      </div>
      {values.land === "DK" ? (
        <div className="w-100 position-relative">
          <AddressFormControl
            config={{
              component: "adresse",
              id: "adresseDar",
              label: "Adresse",
              isRequired: true,
            }}
            formik={formik}
            value={values.adresseDar}
          />
        </div>
      ) : (
        <AddressGenericFormSet formik={formik} hasLandekode={false} />
      )}
    </>
  );
}
